import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
  { path: '*', component: () => import('@/pages/404.vue'), meta: { layout: 'blank' } },
  { path: '', component: () => import('@/pages/Login.vue'), meta: { layout: 'blank' } },
  { path: '/reset-password/:key', component: () => import('@/pages/ResetPassword.vue'), meta: { layout: 'blank' } },
  { path: '/inventory', component: () => import('@/pages/Inventory.vue') },
  { path: '/service', component: () => import('@/pages/StoreService.vue') },
  { path: '/store', component: () => import('@/pages/Store.vue') },
  { path: '/supplier', component: () => import('@/pages/Supplier.vue') },
  { path: '/job/list', component: () => import('@/pages/Job/List.vue') },
  { path: '/job/start', component: () => import('@/pages/Job/Start.vue') },
  { path: '/job/walkin', component: () => import('@/pages/Job/Walkin.vue') },
  { path: '/job/service', component: () => import('@/pages/Job/Service.vue') },
  { path: '/job/claim', component: () => import('@/pages/Job/Claim.vue') },
  { path: '/job/online', component: () => import('@/pages/Job/Online.vue') },
  { path: '/job/fleet', component: () => import('@/pages/Job/Fleet.vue') },
  { path: '/job/store', component: () => import('@/pages/Job/Store.vue') },
  { path: '/schedule', component: () => import('@/pages/Schedule.vue'),
    children: [
      { path: '', component: () => import('@/components/job/schedule/Calendar') },
      { path: 'report', component: () => import('@/components/job/schedule/ReportStock') }
    ] },
  { path: '/accounting', component: () => import('@/pages/Accounting.vue') },
  { path: '/fleet', component: () => import('@/pages/Fleet.vue') },
  { path: '/prospect', component: () => import('@/pages/Prospect.vue') },
  { path: '/customer', component: () => import('@/pages/Customer/Search.vue') },
  { path: '/customer/:key', component: () => import('@/pages/Customer/Detail.vue') },
  { path: '/report', component: () => import('@/pages/Report.vue') }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

export default router;